<template>
  <div class="chat container ">

    <h2 class="center teal-text">Chat App</h2>

    <div class="card">
        <div class="card-content">
            <ul class="message" v-chat-scroll>
                <li v-for="(message, index) in messages" :key="index">
                    <span class="teal-text">{{ message.name }}</span>
                    <span class="grey-text text-darken-3">{{ message.content }}</span>
                    <span class="grey-text time">{{ message.timestamp }}</span>
                </li>
            </ul>
        </div>

        <div class="card-action">
            <NewMessage :name="name" />
        </div>

    </div>

  </div>
</template>

<script>
import NewMessage from '@/components/NewMessage'
import db from '@/firebase/init'
import moment from 'moment'

export default {
    name: 'Chat',
    props: ['name'],
    components: {
        NewMessage
    },
    data() {
        return {
            messages: []
        }
    },
    created() {
        let ref = db.collection('messages').orderBy('timestamp')

        ref.onSnapshot(snapshot => {
            snapshot.docChanges().forEach(change => {
                let doc = change.doc

                this.messages.push({
                    id: doc.id,
                    name: doc.data().name,
                    content: doc.data().content,
                    timestamp: moment(doc.data().timestamp).format('lll'),
                })
            })
        })
    }
}
</script>

<style>
.chat h2{
    font-size: 2.6em;
    margin-bottom: 40px;
}
.chat span{
    font-size: 1.4em;
}
.chat .time{
    display: block;
    font-size: .8em;
}
.message{
    max-height: 300px;
    overflow: auto;
}
.message::-webkit-scrollbar{
    width: 3px;
}
.message::-webkit-scrollbar-track{
    background: #ddd;
}
.message::-webkit-scrollbar-thumb{
    background: #aaa;
}
</style>


// WEBPACK FOOTER //
// src/components/Chat.vue